export default function () {
  const widgetName = "tier2Seo";
  const widgetOpts = tier2SeoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    hasImages: true,
    showDescription: true,
    textOverImage: false,
    buyNowButton: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [""],
    moreButton: {
      visible: true,
      text: "",
    },
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        customWidget(widgetData);
      }
    },
  });

  function customWidget(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $blockModule = $(this);
      const { DetailLinkText } = widgetData[x];

      let buttonText = DetailLinkText !== null ? DetailLinkText : "Learn More";

      $blockModule.find(".buttonwrap a").addClass("button");
      $blockModule.find(".button").removeClass("moreButton ");
      $blockModule.find(".button").removeAttr("target");
      $blockModule.find(".button").text(buttonText);

      $blockModule.find(".image-container, .image-container img").attr({
        "data-aos": "fade-up",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "350",
      });

      $blockModule.find(".card-content").attr({
        "data-aos": "fade-right",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "350",
      });
    });
  }
}
